import truckCreateComponent from './truck.create.component';

let truckCreateModule = angular.module('truckcreate', [
  ])

  .component('truckcreate', truckCreateComponent)

  .name;

export default truckCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/truck/create/index.js